module.exports = __webpack_public_path__ + "static/media/icon-lock.9d0ba2b5.svg";